export default {
  STATUS_OK: 200,
  USER: {
    FREE_MEMBERSHIP: '0',
    APPLYING_MEMBERSHIP: '1',
    PAID_MEMBERSHIP: '2',
    TRIAL_MEMBERSHIP: '3',
  },
  // USER_ICON_LIST: [
  //   'ico_user_blue',
  //   'ico_user_neon_blue',
  //   'ico_user_neon_purple',
  //   'ico_user_xian',
  //   'ico_user_green',
  //   'ico_user_yellow',
  //   'ico_user_orange',
  //   'ico_user_red',
  //   'ico_user_pink',
  //   'ico_user_purple',
  //   'ico_user_brown',
  //   'ico_user_black',
  // ],
  USER_ICON_LIST: [
    'ico_user_1.png',
    'ico_user_2.png',
    'ico_user_3.png',
    'ico_user_4.png',
    'ico_user_5.png',
    'ico_user_6.png',
    'ico_user_7.png',
    'ico_user_8.png',
    'ico_user_9.png',
    'ico_user_10.png',
    'ico_user_11.png',
    'ico_user_12.png'
  ],
  DEFAULT_USER_ICON: 'ico_user_black.svg',
  GOOGLE_TAG_ID: process.env.GOOGLE_TAG_ID,
  APP_STORE_LINK: process.env.APP_STORE_LINK,
  IS_EXAM: process.env.IS_EXAM === 'true',
  ACCEPTED_CONSTRUCTION_USER: 'accpeted',
  INVITE_CONSTRUCTION_USER: 'invite',
  CA_URL: process.env.NODE_ENV === 'production' ? process.env.CA_URL_PROD || 'jp.lecre.ios.zengo://' : process.env.CA_URL_TEST || 'jp.lecre.ios.test.zengo://',
  CONSTRUCTION: {
    EXPIRE_TYPE: {
      FREE: 1,
      SHARE: 2
    }
  },
  MAX_SHARE_CONSTRUCTION: 10,
  TYPE_SEARCH_CONSTRUCTION: {
    construction_name: 0,
    construction_address: 1,
    company_name: 2,
    construction_maker: 3
  },
  TYPE_SEARCH_ACCOUNT: {
    user_name: 0,
    mail_address: 1,
  },
  TYPE_SEARCH_CONSTRUCTION_SITE: {
    name: 0,
    comment: 1,
    shooting_date: 2
  },
  REPORT_PDF_TYPE_IMAGE: 5,
  ACCOUNT_STATUS_TEXT: {
    '0': '利用中',
    '1': '利用停止',
  },
  ACCOUNT_LEVEL_AUTHORITY: [1, 2],
  ADMIN_LEVEL: 1,
  SUPERVISOR_LEVEL: 2,
  OPERATOR_LEVEL: 3,
  PAGE_SIZE: process.env.PAGE_SIZE || 20,
  STAMP_LIST: {
    CIRCLE: [
      'circle_red.png',
      'circle_black.png',
      'circle_white.png',
      'circle2_red.png',
      'circle2_black.png',
      'circle2_white.png'
    ],
    ARROW: [
      'arrow_red.png',
      'arrow_black.png',
      'arrow_white.png',
      'arrow_line_red.png',
      'arrow_line_black.png',
      'arrow_line_white.png',
    ]
  },
  ACTION_WEB_LOG: {
    ACTION_WEB_MAKE_ACCOUNT: 'action_web_make_account',
    ACTION_WEB_REGIST_ACCOUNT: 'action_web_regist_account',
    ACTION_WEB_MAKE_CONSTRUCTION: 'action_web_make_construction',
    ACTION_WEB_EDIT_CONSTRUCTION: 'action_web_edit_construction',
    ACTION_WEB_DELETE_CONSTRUCTION: 'action_web_delete_construction',
    ACTION_WEB_COPY_CONSTRUCTION: 'action_web_copy_construction',
    ACTION_WEB_MAKE_SITE: 'action_web_make_site',
    ACTION_WEB_DELETE_SITE: 'action_web_delete_site',
    ACTION_WEB_SORT_SITE: 'action_web_sort_site',
    ACTION_WEB_COPY_SITE: 'action_web_copy_site',
    ACTION_WEB_EDIT_SITE: 'action_web_edit_site',
    ACTION_WEB_RENAME_SITE: 'action_web_rename_site',
    ACTION_WEB_CHANGE_PHOTO: 'action_web_change_photo',
    ACTION_WEB_DRAW_PHOTO: 'action_web_draw_photo',
    ACTION_WEB_PREVIEW_REPORT: 'action_web_preview_report',
    ACTION_WEB_EXCELL_OUTPUT: 'action_web_excel_output',
    ACTION_WEB_STATUS_COMPLETION: 'action_web_status_completion'
  },
  CONSTRUCTION_VERSION_2: 2,
  REPORT_PDF_TYPE_2_PAGES: 2,
  DAIKIN_COMPANY_ID: 'daikin',
  VERTICAL_TYPE: 'vertical',
  DEDICATE_REPORT_MODE: 'dedicate',
  CONSTRUCTION_STATUS_TEXT: {
    0: '作業待ち',
    1: '作業済み',
    2: '完了',
  },
  ACTION_WEB_LOG_DISPLAY: {
    'action_app_make_construction': '案件を新しく作成した',
    'action_app_make_site': '箇所を新しく作成した',
    'action_app_edit_construction': '案件を編集して保存した',
    'action_app_delete_construction': '案件を削除した',
    'action_app_shoot_photo_before': '前写真を撮影した',
    'action_app_shoot_photo_after': '中/後写真を撮影した',
    'action_app_edit_site': '箇所編集をした',
    'action_app_rename_site': '箇所名を編集した',
    'action_app_delete_site': '箇所を削除した',
    'action_app_change_photo': 'フォトライブラリもしくは再撮影で写真を入れ替えた',
    'action_app_draw_photo': '図形描画を保存した',
    'action_app_sync_cloud': 'ZENGO連携をした',
    'action_web_make_account': 'メールアドレスを入力して「送信する」を押した(仮登録)',
    'action_web_regist_account': 'アカウント作成画面で「登録する」を押した(本登録)',
    'action_web_make_construction': '案件を新しく作成した',
    'action_web_edit_construction': '案件を編集して保存した',
    'action_web_delete_construction': '案件を削除した',
    'action_web_copy_construction': '案件をコピーした',
    'action_web_make_site': '箇所を新しく作成した',
    'action_web_delete_site': '箇所を削除した',
    'action_web_sort_site': '箇所を並び替えした',
    'action_web_copy_site': '箇所をコピーした',
    'action_web_edit_site': '箇所編集をした',
    'action_web_rename_site': '箇所名を編集した',
    'action_web_change_photo': 'フォトライブラリで写真を入れ替えた',
    'action_web_draw_photo': '図形描画を保存した',
    'action_web_preview_report': '報告書を作成した(報告書プレビュー画面を開いた)',
    'action_web_status_completion': '「完了」にした',
  },
}



// WEBPACK FOOTER //
// ./src/configs/constant.js